import { Component, Input, OnInit } from '@angular/core';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { Events } from '@app/events/events/events.model';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Logger } from '@app/core';
import { HotelsService } from '@app/hotels/hotels/hotels.service';
import { ApiQuery } from '@app/core/http/api-query';

const log = new Logger('LinksComponent');

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss'],
})
export class LinksComponent implements OnInit {
  @Input() data: Events | EventGroup | Hotel;
  companyWebsiteLocales: Array<any>;
  currentWebsiteLocaleId: number;

  constructor(
    public modal: NgbActiveModal,
    private websitesService: WebsitesService,
    private hotelService: HotelsService
  ) {}

  ngOnInit() {
    log.debug('init');
    if (!this.data) {
      throw Error('No data passed to component!');
    }
    this.getData();
  }

  selectCompanyWebSiteLocale(id: number): void {
    this.currentWebsiteLocaleId = id;
  }

  getWebsiteLocaleName(id: number): string {
    log.debug('getWebsiteLocaleName id', id);
    const localeObj = this.companyWebsiteLocales.find((x) => x.id === id);
    return localeObj.website.name + ' ' + localeObj.website.url + ' ' + localeObj.locale.locale;
  }

  copyInputMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  private getData() {
    this.websitesService.getLocales().subscribe((websiteLocales: []) => {
      this.companyWebsiteLocales = websiteLocales;

      const query = new ApiQuery().addInclude('links');
      if (this.data instanceof Hotel) {
        this.hotelService.show(this.data.id, query).subscribe((hotel: Hotel) => {
          log.debug('load hotel', hotel);

          this.companyWebsiteLocales.forEach((webSiteLocale: any) => {
            webSiteLocale['links'] = [];
            hotel.links.forEach((link: any) => {
              if (link.company_website_locale_id === Number(webSiteLocale.id)) {
                webSiteLocale.links.push(link);
              }
            });
          });
        });
      }
    });
  }
}
